import { useMemo } from 'react';
import { useAdminJobs, useAdminRuns, useAdminUsers } from '../api/admin';
import {
  AdminError,
  AdminSection,
  AdminShell,
  AdminJobsTable,
  AdminRunsTable,
  AdminSkeletonRows,
  UsersTable,
} from './adminShared';

export function AdminPage() {
  const users = useAdminUsers();
  const jobs = useAdminJobs();
  const runs = useAdminRuns();
  const userEmails = useMemo(
    () => new Map((users.data ?? []).map((u) => [u.id, u.email])),
    [users.data],
  );

  return (
    <AdminShell title="Admin" subtitle="Recent control-plane activity across all users.">
      <AdminSection title="Users">
        {users.isPending && <AdminSkeletonRows />}
        {users.error && (
          <AdminError subject="users" error={users.error} onRetry={() => void users.refetch()} />
        )}
        {users.data && <UsersTable users={users.data} />}
      </AdminSection>

      <AdminSection title="Recent jobs">
        {jobs.isPending && <AdminSkeletonRows />}
        {jobs.error && (
          <AdminError subject="jobs" error={jobs.error} onRetry={() => void jobs.refetch()} />
        )}
        {jobs.data && <AdminJobsTable jobs={jobs.data} userEmails={userEmails} />}
      </AdminSection>

      <AdminSection title="Recent runs">
        {runs.isPending && <AdminSkeletonRows />}
        {runs.error && (
          <AdminError subject="runs" error={runs.error} onRetry={() => void runs.refetch()} />
        )}
        {runs.data && <AdminRunsTable runs={runs.data} userEmails={userEmails} />}
      </AdminSection>
    </AdminShell>
  );
}
